module.exports = __webpack_public_path__ + "static/img/3.3c04a26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-salud/3.png
// module id = D6Eq
// module chunks = 0